import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTwitterSquare,
  faFacebookSquare,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import {
  faMapMarkerAlt,
  faMobileAlt,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faEnvelope,
} from '@fortawesome/pro-regular-svg-icons';

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      twitter: this.props.site_info.twitter,
      facebook: this.props.site_info.facebook,
      instagram: this.props.site_info.instagram,
    };
  }

  formatPhone(phone) {
    return phone.replace(/\D/g, '');
  }

  getUsername(url, site) {
    // check if url is in @username format
    if ((url.indexOf('@') === 0)) {
      return url.substring(1);
    }

    // check if url is valid or is already the username
    if ((url.indexOf('.com') === -1) || (url.indexOf('/') === -1)) {
      return url;
    }

    // strip away variables first
    let new_url = url;
    if ((url.indexOf('?') > -1)) {
      const old_url = url;
      new_url = old_url.substring(0, old_url.indexOf('?'));
    }
    const parts = new_url.split('/');
    let count = 0;
    const domain = `${site}.com`;
    for (let i = 0; i < parts.length; i++) {
      const element = parts[i];
      if (element.indexOf(domain) > -1) {
        i = parts.length;
      } else {
        count++;
      }
    }
    const username = parts[count + 1];
    return username;
  }

  componentDidMount() {
    // console.log('Footer: componentDidMount');
    this.setState({
      facebook: this.getUsername(this.state.facebook, 'facebook'),
      twitter: this.getUsername(this.state.twitter, 'twitter'),
      instagram: this.getUsername(this.state.instagram, 'instagram'),
    });
  }

  render() {
    const year = new Date().getFullYear();
    return (
      <Fragment>
        <footer>
          <div className="title">{this.props.site_info.site_title}</div>

          {/* Email */}
          {this.props.site_info.email && (
          <div className="email-wrapper contact-wrapper">
            <div className="email contact-block">
              <FontAwesomeIcon icon={faEnvelope} />
              {' '}
              <a href={`mailto:${this.props.site_info.email}`}>{this.props.site_info.email}</a>
            </div>
          </div>
          )}

          {/* Phone */}
          {this.props.site_info.phone && (
          <div className="phone-wrapper contact-wrapper">
            <div className="phone contact-block">
              <FontAwesomeIcon icon={faMobileAlt} />
              {' '}
              <div itemScope itemType="http://schema.org/LocalBusiness" className="google-wrap">
                <h1 itemProp="name">{this.props.site_info.site_title}</h1>
                <span itemProp="telephone">
                  <a href={`tel:+1${this.formatPhone(this.props.site_info.phone)}`}>{this.props.site_info.phone}</a>
                </span>
              </div>
            </div>
          </div>
          )}

          {/* Address */}
          {this.props.site_info.address && (
          <div className="address-wrapper contact-wrapper">
            <div className="address contact-block">
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              {' '}
              <a href={`https://maps.google.com/?q=${this.props.site_info.address}`}>{this.props.site_info.address}</a>
            </div>
          </div>
          )}

          <div className="social-wrapper">
            {/* Twitter */}
            {this.state.twitter && (
            <a href={`https://twitter.com/${this.state.twitter}`} className="social-link">
              <FontAwesomeIcon icon={faTwitterSquare} />
            </a>
            )}
            {/* Facebook */}
            {this.state.facebook && (
              <a href={`https://facebook.com/${this.state.facebook}`} className="social-link">
                <FontAwesomeIcon icon={faFacebookSquare} />
              </a>
            )}
            {/* Instagram */}
            {this.state.instagram && (
              <a href={`https://instagram.com/${this.state.instagram}`} className="social-link">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            )}
          </div>
          <div className="copyright">
©
            {' '}
            {(year)}
          </div>
        </footer>
      </Fragment>
    );
  }
}

export default Footer;
